"use client";
import SectionPage from "@/components/common/section-page";

import EspaceProTitleCard from "@/components/common/espace-pro-title-card";
import {TitleSectionEspaceProLarge} from "@/components/common/title-section-espace-pro";
import {PaveScaleCard} from "@/components/common/pave-scale-card";

export default function Home() {

    return (
        <div className={"flex flex-col gap-6 pb-6 mb-8"}>


            <EspaceProTitleCard title={"Réglementation"}
                                middleBreadcrumbs={[
                                    {title: "Pôle de l’Observation et des Etudes", link: "/espace-pro/pole-observation-etudes"},
                                ]}
                                description={"L’approche du tourisme est économique et sous cet angle, le tourisme s’entend des activités des personnes appelées visiteurs."}/>

            {/* Nature & Biodiversité */}
            <SectionPage sectionType="lg">
                <TitleSectionEspaceProLarge title={"Code du tourisme"} />

                <div className={"grid grid-cols-1 md:grid-cols-5 gap-4"}>
                    <PaveScaleCard title={<>Activités <br/> ou professions touristiquees</>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Activites-ou-professions-touristiques.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/reglementations/1.jpg"}
                                   titleClassName={"font-exo font-bold text-xl mb-16"}/>

                    <PaveScaleCard title={<>Code <br/> du Tourisme</>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Code-du-tourisme.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/reglementations/1.jpg"}
                                   titleClassName={"font-exo font-bold text-xl mb-16"}/>

                    <PaveScaleCard title={<>Décret Côte d'Ivoire Tourisme</>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Decret-Cote-dIvoire-Tourisme-2014-08-du-8-janvier-2014.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/reglementations/1.jpg"}
                                   titleClassName={"font-exo font-bold text-xl mb-16"}/>

                    <PaveScaleCard title={<>Taxes embarquement et débarquement passagers</>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Taxes-embarquement-et-deparquement-passagers-.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/reglementations/1.jpg"}
                                   titleClassName={"font-exo font-bold text-xl mb-16"}/>

                    <PaveScaleCard title={<>Taxe de développement touristique</>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Taxe-de-developpement-touristique.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/reglementations/1.jpg"}
                                   titleClassName={"font-exo font-bold text-xl mb-16"}/>
                </div>
            </SectionPage>


            {/* Nature & Biodiversité */}
            <SectionPage sectionType="lg">
                <TitleSectionEspaceProLarge title={"Fiscalité"} />

                <div className={"grid grid-cols-1 md:grid-cols-5 gap-4"}>
                    <PaveScaleCard title={<>Code des investissements</>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Code-des-investissements.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/reglementations/2.jpg"}
                                   titleClassName={"font-exo font-bold text-xl mb-16"}/>

                    <PaveScaleCard title={<>Les modalités de mise en application de la suspension de la TVA</>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Les-modalites-de-mise-en-application-de-la-suspension-de-la-TVA.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/reglementations/2.jpg"}
                                   titleClassName={"font-exo font-bold text-xl mb-16"}/>

                    <PaveScaleCard title={<>Modalités de l'application de l'ordonnance</>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Modalites-dapplication-de-lordonnance.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/reglementations/2.jpg"}
                                   titleClassName={"font-exo font-bold text-xl mb-16"}/>

                    <PaveScaleCard title={<>Modifications sur le code des investissements</>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Modification-sur-le-code-des-investissements.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/reglementations/2.jpg"}
                                   titleClassName={"font-exo font-bold text-xl mb-16"}/>

                    <PaveScaleCard title={<>Tableau des agglomérations sur le code des investissements</>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Tableau-des-agglomerations-concernees-par-le-code-des-investissements.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/reglementations/2.jpg"}
                                   titleClassName={"font-exo font-bold text-xl mb-16"}/>
                </div>
            </SectionPage>


            {/* Nature & Biodiversité */}
            <SectionPage sectionType="lg">
                <TitleSectionEspaceProLarge title={"Textes & Lois"} />

                <div className={"grid grid-cols-1 md:grid-cols-5 gap-4"}>
                    <PaveScaleCard title={<>Attributions membres du Gouvernement</>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Attibutions-membres-du-Gouvernement.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/reglementations/3.jpg"}
                                   titleClassName={"font-exo font-bold text-xl mb-16"}/>

                    <PaveScaleCard title={<>Code Aviation Civile</>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Code-Aviation-Civile-CI.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/reglementations/3.jpg"}
                                   titleClassName={"font-exo font-bold text-xl mb-16"}/>

                    <PaveScaleCard title={<>Code dud travail</>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Code-du-travail.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/reglementations/3.jpg"}
                                   titleClassName={"font-exo font-bold text-xl mb-16"}/>

                    <PaveScaleCard title={<>Loi relative aux EPN</>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Loi-relative-aux-EPN.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/reglementations/3.jpg"}
                                   titleClassName={"font-exo font-bold text-xl mb-16"}/>

                    <PaveScaleCard title={<>Modalités d'immatriculation au reegistre des métiers</>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Modalites-dimmatriculation-au-registre-des-metiers.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/reglementations/3.jpg"}
                                   titleClassName={"font-exo font-bold text-xl mb-16"}/>
                </div>
            </SectionPage>

        </div>
    );
}
